import script from "./ContractWarning.vue?vue&type=script&lang=ts&setup=true&name=ContractWarning"
export * from "./ContractWarning.vue?vue&type=script&lang=ts&setup=true&name=ContractWarning"

import "./ContractWarning.vue?vue&type=style&index=0&id=72b2caf3&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b2caf3"]])

export default __exports__